import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  GenerateMoreLeadSuggestedContactsMutation,
  GenerateMoreLeadSuggestedContactsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "lib/hooks/api/useGraphQlClient";

const GENERATE_MORE_LEAD_SUGGESTED_CONTACTS_MUTATION = graphql(`
  mutation generateMoreLeadSuggestedContacts($leadId: String!) {
    generateMoreLeadSuggestedContacts(leadId: $leadId)
  }
`);

/**
 * On-demand "load more" for a lead's AI-suggested contacts: ranks a fresh batch (excluding
 * already-seen contacts), appends them, and refetches the lead on success. Resolves with the number
 * of new suggestions added (0 when the buyer has no more relevant contacts).
 */
export function useGenerateMoreLeadSuggestedContacts(
  leadId: string,
  options?: UseMutationOptions<
    GenerateMoreLeadSuggestedContactsMutation,
    unknown,
    GenerateMoreLeadSuggestedContactsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(GENERATE_MORE_LEAD_SUGGESTED_CONTACTS_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(["lead", leadId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
}
